// hier staan zaken die NIET relevant zijn voor de reserveerstraat
// dit zijn dus dingen die gebruikt worden door losse widgets in de site
// Omgekeerd mogen die componenten wel de overige stores/features gebruiken maar dan moet
// je er dus wel rekening mee houden wat er wel en niet is gevuld op een pagina buiten de reserveerstraat

export let widgets_json = {
  shared: null
};

export const widgets = $state({
  bIsThisAWidgetBuildInsteadOfTheShop: false,
  bWasWidgetsSharedBootSequenceStarted: false,
  bWasBaseJSONForWidgetsReceived: false,
  bWasBaseJSONForWidgetsParsed: false
});

window.hmk_widgets_json = () => {
  console.log(widgets_json);
}
